import * as Types from '../types'

export const onFailedPaymentOrderWarningSeen = () => {
    return dispatch => {
        dispatch({ type: Types.HANDLE_FAILED_PAYMENT_ORDER_WARNING_SEEN })
    }
}
